export enum SPACING {
  X_SMALL = "4px",
  SMALL = "8px",
  MEDIUM = "16px",
  LARGE = "24px",
  X_LARGE = "32px",
  XXX_LARGE = "120px",
}
